module.exports = __webpack_public_path__ + "img/profile.4449c6b6.svg";